<app-nav></app-nav>
<section class="login-section set-profile">
  <div class="container">
    <span id="snackbar"></span>
    <div class="update-profile datepicker">
      <h5 mt-2>Complete Profile</h5>
      <p *ngIf="!this.isReadOnlyEmail">Your email id is not with us,which is mandatory.Kindly complete your profile first.</p>
      <p *ngIf="!this.isReadOnlyMobile">Your mobile number is not with us,which is mandatory.Kindly complete your profile first.</p>
      <form #updateProfileForm="ngForm" (ngSubmit)="updateProfileDetails()">
        <div class="row">
          <div class="col-12 form-group">
            <label>Name</label>
            <input type="text" pattern="[a-zA-Z\s]+" maxlength="200" class="form-control" name="name" #name="ngModel"
              [(ngModel)]="profileData.name">
            <div *ngIf="name.invalid && name.touched " class="error-message">
              <div *ngIf="name.errors.required">
                Name is required.
              </div>
              <div *ngIf="name.errors.pattern">
                Please enter valid name.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-6 form-group">
            <label>Mobile No.</label>
            <input type="text" class="form-control" pattern="^((?!(0))[0-9]{1,10}\d*)$" minlength="10" maxlength="10"
              #mobile="ngModel" name="mobile" inputmode="numeric" [(ngModel)]="profileData.mobile"
              (keydown.space)="$event.preventDefault();" required [readonly]="isReadOnlyMobile">
          </div>
          <div class="col-6 form-group">
            <label>Date of Birth</label>
            <div class="input-group addon">
              <p-calendar class="dob-calendar" [maxDate]="profileMaxDate" [touchUI]="true" [readonlyInput]="true"
                name="dob" id="dob" placeholder="Date of Birth" #dob="ngModel" [(ngModel)]="profileData.dob"
                value="{{profileData.dob}}" dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                yearRange="1960:2023">
              </p-calendar>
            </div>
            <!-- <input type="text" class="form-control" name="dob" [(ngModel)]="profileData.dob"> -->
          </div>
          <div class="col-12 mt15-m">
            <div *ngIf="mobile.invalid && mobile.touched " class="error-message">
              <div *ngIf="mobile.errors.required">
                Mobile number is required.
              </div>
              <div *ngIf="(!mobile.errors.minlength || mobile.errors.pattern) && !mobile.errors.required">
                Invalid mobile number.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 form-group">
            <label>Email Address</label>
            <input type="text" class="form-control" maxlength="100"
              pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" name="email" #email="ngModel"
              [(ngModel)]="profileData.email" required [readonly]="isReadOnlyEmail">
            <div *ngIf="email.invalid && email.touched " class="error-message">
              <div *ngIf="email.errors.required">
                Email is required.
              </div>
              <div *ngIf="email.errors.pattern">
                Please enter valid email.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 form-group">
            <label>Company</label>
            <input type="text" maxlength="200" class="form-control" name="company" #company="ngModel" [(ngModel)]="profileData.company"
              >
            <div *ngIf="company.invalid && company.touched " class="error-message">
              <div *ngIf="company.errors.required">
                Company is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12 text-center">
            <button *ngIf="isReadOnlyEmail && isReadOnlyMobile" type="button" class="border-btn mx-1" (click)="goToHome();">Go to Home</button>
            <button *ngIf="!isReadOnlyEmail || !isReadOnlyMobile" type="button" class="border-btn mx-1" (click)="logOut();">Logout</button>
            <button type="submit" class="border-btn" [disabled]="!updateProfileForm.valid">Save</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>